import commonMapping from "@/mapping/common";

export const resetPassword = {
  "validate.answer1": commonMapping.pwdEncrypt,
  "validate.answer2": commonMapping.pwdEncrypt,
  "resetpwd.new_password": commonMapping.pwdEncrypt,
  "resetpwd.confirm_password": commonMapping.pwdEncrypt,
  "resetpwd.answer1": commonMapping.pwdEncrypt,
  "resetpwd.answer2": commonMapping.pwdEncrypt,
  "resetpwd.question1": commonMapping.question1List,
  "resetpwd.question2": commonMapping.question2List,
};

export default resetPassword;
